import { createContext, useContext } from "react";
import type { PipelineStage } from "@school-sales-ai/shared";

export type BoardMove = {
  /** Every column of the board, in board order — never the filtered subset. */
  stages: PipelineStage[];
  /** Move a lead under the board's rule: straight, or through StageReasonModal. */
  requestMove: (leadId: string, fromStage: string, toStage: string) => void;
};

// How a card's «…» menu reaches the board's move path. A context rather than a
// prop because KanbanCard is memoized with a comparator that ignores callbacks:
// a prop would keep the closure from whichever render first mounted the card.
export const BoardMoveContext = createContext<BoardMove | null>(null);

/** `null` outside a board — the menu then offers no moves. */
export function useBoardMove(): BoardMove | null {
  return useContext(BoardMoveContext);
}
